/* Revezamento entre o aviso de esgotado e a barra de frete gratis, abaixo do
   botao de comprar.

   Quem decide e o proprio botao: o Dawn poe e tira o atributo disabled dele
   conforme a variante escolhida (product-info.js -> toggleSubmitButton), tanto
   na variante esgotada quanto na combinacao que nem existe. Vigiar esse
   atributo pega os dois casos de uma vez e nao depende de o carregamento da
   pagina ter acontecido em alguma ordem especifica.

   Cuidado ao mexer: enquanto o "adicionar ao carrinho" esta em andamento, o
   product-form.js usa aria-disabled, nao disabled — por isso o observer filtra
   so o disabled. Se trocar para aria-disabled, o aviso de lancamento vai piscar
   no meio de cada compra. */

if (!customElements.get('vorcaro-esgotado')) {
  customElements.define(
    'vorcaro-esgotado',
    class VorcaroEsgotado extends HTMLElement {
      connectedCallback() {
        const botao = document.getElementById(this.dataset.botao);
        if (!botao) return;

        this.observer = new MutationObserver(() => this.sincronizar(botao));
        this.observer.observe(botao, { attributes: true, attributeFilter: ['disabled'] });
        this.sincronizar(botao);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      sincronizar(botao) {
        this.toggleAttribute('data-esgotado', botao.hasAttribute('disabled'));
      }
    }
  );
}
